export const normalizeCartItem = (item) => {
  const price = item.size?.price || 0;
  const mrp = item.size?.mrp || 0;
  const quantity = item.quantity || 1;

  const discountPercent =
    mrp > price ? Math.round(((mrp - price) / mrp) * 100) : 0;

  return {
    _id: item._id || item.size?._id, // fallback for guest cart
    productId: item.product?._id,
    variantId: item.variant?._id,
    sizeId: item.size?._id,
    productName: item.product?.name || "",
    image: item.variant.images?.[0] || "https://via.placeholder.com/90x120",
    size: item.size?.size,
    color: item.variant?.colorCode || item.variant?.colorCode || "",
    quantity,
    price,
    mrp,
    discountPercent,
    total: price * quantity,
    stock: item.size?.stock || 0,
    outOfStock: item.size?.stock === 0,
  };
};
